import { AbstractControl, ValidationErrors, Validators } from '@angular/forms';
import { BaseValidator } from '@shared/validators/base-validator';
import { BaseValidationError } from '@shared/validators/validation-error/base-error';
import { isFunction } from '@shared/functions/is-function';
import { TranslationService } from '@core/translation/translation.service';

export class U2BRequiredValidator extends BaseValidator {

    public validationError: BaseValidationError;

    constructor(public message = TranslationService.translate('common.validation.enterValue'),
                private _callback?: () => boolean) {
        super();
        this.validationError = new BaseValidationError('required', message);
    }

    public validate(control: AbstractControl): ValidationErrors | null {

        // If there's a callback and it returns false, the field is not required
        if (isFunction(this._callback) && !this._callback()) {
            return this.IS_VALID;
        }

        return Validators.required(control) ?
            this.IS_INVALID :
            this.IS_VALID;
    }
}
